import { Input, Directive } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PageInstance } from '@workflow/class/page.service';
import { CardInstance } from '@workflow/class/card.service';
import { FlowInstance } from '@workflow/class/flow.service';

/** Base Component Class for card elements */
@Directive()
export class CardElementsBaseComponent {
  /** * Dynamic Page object.  */
  @Input()
  public flow: FlowInstance;

  /** * Dynamic Page object.  */
  @Input()
  public page: PageInstance;

  /** Dynamic Card object. */
  @Input()
  public card: CardInstance;

  /** Card index in page cards array. */
  @Input() public cardIndex: number;

  /** Page Submitted Observable. */
  @Input()
  public pageSubmitted$: Observable<boolean> = of(false);
}
